import { useEffect } from "react";
import BannerPagesInst from "../../components/BannerPagesInst";
import AboutImg from "./assets/sobre.png";

import {
  AreaContent,
  Container,
  ContentInfos,
  ImageWorks,
  TitleContent,
} from "./styles";

const About = () => {
  const handleGoToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    handleGoToTop();
  }, []);
  return (
    <Container>
      <BannerPagesInst title="A empresa" />
      <AreaContent>
        <ImageWorks src={AboutImg} alt="como funciona" />
        <ContentInfos>
          <TitleContent>Sobre a coob+</TitleContent>
          <p>
            Coob+ é uma plataforma de assinatura de viagens em que você
            economiza até 60% no valor das diárias nos hotéis, já com café da
            manhã.
          </p>
          <p>
            São mais de 1.900 opções de hotéis para explorar todo o Brasil,
            tendo até 3 anos para utilizar as diárias. A era das assinaturas faz
            com que você realize sonhos por um pequeno valor mensal, e na Coob +
            não podia ser diferente. Temos sempre um lugar reservado para os
            sonhos de quem vive a vida em movimento e não abre mão do prazer de
            ser e estar!
          </p>
          <p>“Viaje mais, viaje Coob+”</p>
        </ContentInfos>
      </AreaContent>
    </Container>
  );
};

export default About;
